import React, { useMemo } from "react";
import classNames from "classnames";

const Button = ({
  children,
  clickFunction,
  type = "button",
  disabled = false,
  transparent = false,
  isCommon = false,
  isFullWidth = false,
  isActive = false,
}) => {
  const classesForBtn = useMemo(() => {
    if (!!isCommon) {
      return "common-btn";
    } else {
      if (transparent) {
        return  "border-btn";
      } else {
        return "orange-btn";
      }
    }
  }, []);

  return (
    <button
      type={type}
      className={classNames({
        "border-btn": !isCommon && !transparent,
        "orange-btn": !isCommon && !!transparent,
        "common-btn": !!isCommon,
        "common-btn--active":!!isCommon && !!isActive,
        "fullwidth-btn": !!isFullWidth,
      })}
      onClick={clickFunction}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
